export default {
    CPA: 0,
    CPC: 1,
    CPL: 2,
    CPO: 3
}